import React from 'react';

import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';

const URL= WS.paginas.sobre;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false
    };
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL,
      data:{ htmldb: 1 },
      sucess:function(data){
        var msg;
        _self.setState({
          page: data,
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }


  render() {
    const view = this.state.loaded ? null : this.state.page;
    return (
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Sobre o Foco90"></MainTitle>
              <div dangerouslySetInnerHTML={{__html: view}}>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/sobre/Page.js